//====================================================
//  Initialization Aos
//  (data-aos="fade-in" data-aos-delay="100" data-aos-once="true" data-aos-duration="700")
//====================================================
function componentAOS() {
  AOS.init()
}
